export const UNDEFINED = 'undefined';
export const TEXT = 'text';
export const EMAIL = 'email';
export const PASSWORD = 'password';
export const PASSWORD_CONFIRMATION = 'password_confirmation';
export const DROPDOWN = 'dropdown';
export const DROPDOWNS_GROUP = 'dropdowns_group';
export const DROPDOWN_WITH_OTHER = 'dropdown_with_other';
export const PP_DROPDOWN = 'pp_dropdown';
export const RADIO_BUTTONS = 'radio_buttons';
export const CHECKBOXES = 'checkboxes';
export const NUMBER = 'number';
export const PHONE_NUMBER = 'phone_number';
export const DATE = 'date';
export const COUNTRY = 'country';
export const MASTERCARD = 'mastercard';
export const FAVORITE_PLAYER = 'favorite_player';
export const ONE_CLUB_FREE_TEXT = 'one_club_free_text';
export const YES_OPTION = 'yes';
export const PASSWORD_WITH_CONFIRM_AND_MULTIPLE_VALIDATION =
  'password_with_confirm_and_multiple_validation';
export const ATTACHMENT = 'attachment';
export const HIDDEN_FIELD_WITH_VALUE = 'hidden_field_with_value';
export const NUMBERED_CHECKBOXES = 'numbered_checkboxes';
export const NUMBERED_CHECKBOXES_WITH_OTHER = 'numbered_checkboxes_with_other';
